<template>
    <div class="question">
        <div class="title">
            {{ result.key_behavior.title }}
        </div>
        <b-row no-gutters>
            <b-col
                v-if="result.rating_score !== null || result.classification !== null"
                cols="12"
                xl="3"
                order-xl="2"
                class="final mb-2 mb-xl-0"
            >
                <div class="score">
                    <span>{{ $t('values.networksAverage') }}</span>
                    <span v-if="result.rating_score !== null" class="separator" />
                    <span v-if="result.rating_score !== null">{{ result.rating_score | formatNumber }}</span>
                </div>
                <div v-if="result.classification !== null">
                    {{ result.classification }}
                </div>
            </b-col>
            <b-col
                v-if="result.calibrated_score !== null || result.classification_calibrated_score !== null"
                cols="12"
                xl="3"
                order-xl="2"
                class="final ml-1 mb-2 mb-xl-0"
            >
                <div
                    v-if="result.calibrated_score !== null || result.classification_calibrated_score !== null"
                    class="score"
                >
                    <span>{{ $t('values.calibratedScore') }}</span>
                    <span v-if="result.calibrated_score !== null" class="separator" />
                    <span v-if="result.calibrated_score !== null">{{ result.calibrated_score | formatNumber }}</span>
                </div>
                <div v-if="result.classification_calibrated_score !== null">
                    {{ result.classification_calibrated_score }}
                </div>
            </b-col>
            <b-col>
                <b-row v-if="networkHasResults">
                    <b-col
                        :key="network"
                        v-for="(networkResults, network) in orderedNetworksResults"
                        :cols="12"
                        :lg="networkResultsColumnSize"
                        class="network mb-2 mb-lg-0"
                    >
                        <div class="score">
                            <span>{{ $t('values.network.types.' + networkResults.string) }}</span>
                            <span v-if="networkResults.answer_score !== null" class="separator" />
                            <span v-if="networkResults.answer_score !== null">
                                {{ networkResults.answer_score | formatNumber }}</span
                            >
                            <div v-if="networkResults.score == null">-</div>
                        </div>
                        <div v-if="networkResults.answer">
                            {{ networkResults.answer }}
                        </div>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col>
                        <span
                            ><i>{{ $t('values.questionWithNoResults') }}</i></span
                        >
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { orderedNetworksMixin } from '@/mixins'
import { sortBy } from 'lodash'

export default {
    mixins: [orderedNetworksMixin],
    props: {
        result: {
            type: Object,
            required: true,
        },
    },
    computed: {
        networkResultsColumnSize() {
            const count = Object.keys(this.result.networks_results).length
            return 12 / count
        },
        orderedNetworksResults() {
            let ordered = this.orderNetworks(this.result.networks_results)
            let sortered = sortBy(ordered, 'order')
            return sortered
        },
        networkHasResults() {
            return Object.keys(this.result.networks_results).length > 0
        },
    },
}
</script>
<style lang="sass" scoped>
.final
    display: flex
    flex-direction: column
    align-self: center
    text-align: center
    align-items: center
    justify-content: center
    padding: 10px
    border-radius: 3px
    background-color: #E4E5E6
    min-height: 75px

.question
    color: #6E6E6E
    margin-bottom: 16px
    .title
        font-weight: 700
        font-size: 15px
        margin-bottom: 12px
</style>
